import { TNewbuildingBrokerCallbackWidgetClickType } from 'shared/types/newbuildingBrokerOfferBooking';
import { actionGenerator } from 'shared/utils/redux/actionGenerator';

export enum ENewbuildingBrokerOfferBookingActions {
  SetEnabled = 'newbuildingBrokerOfferBooking/setEnabled',
  OpenCallbackWidget = 'newbuildingBrokerOfferBooking/openCallbackWidget',
  CloseCallbackWidget = 'newbuildingBrokerOfferBooking/closeCallbackWidget',
  SetGalleryBannerAnalyticsSent = 'newbuildingBrokerOfferBooking/setGalleryBannerAnalyticsSent',
  SetLoading = 'newbuildingBrokerOfferBooking/setLoading',
  ToggleBookingExistsModal = 'newbuildingBrokerOfferBooking/toggleBookingExistsModal',
  ToggleProfessionalAccessBlockedModal = 'newbuildingBrokerOfferBooking/toggleProfessionalAccessBlockedModal',
}

export const setNewbuildingBrokerOfferBookingEnabled = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.SetEnabled,
  boolean
>(ENewbuildingBrokerOfferBookingActions.SetEnabled);

export const openNewbuildingBrokerCallbackWidget = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget,
  TNewbuildingBrokerCallbackWidgetClickType
>(ENewbuildingBrokerOfferBookingActions.OpenCallbackWidget);

export const closeNewbuildingBrokerCallbackWidget =
  actionGenerator<ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget>(
    ENewbuildingBrokerOfferBookingActions.CloseCallbackWidget,
  );

export const setGalleryBannerAnalyticsSent =
  actionGenerator<ENewbuildingBrokerOfferBookingActions.SetGalleryBannerAnalyticsSent>(
    ENewbuildingBrokerOfferBookingActions.SetGalleryBannerAnalyticsSent,
  );

export const setNewbuildingBrokerOfferBookingLoading = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.SetLoading,
  boolean
>(ENewbuildingBrokerOfferBookingActions.SetLoading);

export const toggleNewbuildingBrokerOfferBookingExistsModal = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.ToggleBookingExistsModal,
  boolean
>(ENewbuildingBrokerOfferBookingActions.ToggleBookingExistsModal);

export const toggleNewbuildingBrokerProfessionalAccessBlockedModal = actionGenerator<
  ENewbuildingBrokerOfferBookingActions.ToggleProfessionalAccessBlockedModal,
  boolean
>(ENewbuildingBrokerOfferBookingActions.ToggleProfessionalAccessBlockedModal);

export type TNewbuildingBrokerOfferBookingActions =
  | ReturnType<typeof setNewbuildingBrokerOfferBookingEnabled>
  | ReturnType<typeof openNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof closeNewbuildingBrokerCallbackWidget>
  | ReturnType<typeof setGalleryBannerAnalyticsSent>
  | ReturnType<typeof setNewbuildingBrokerOfferBookingLoading>
  | ReturnType<typeof toggleNewbuildingBrokerOfferBookingExistsModal>
  | ReturnType<typeof toggleNewbuildingBrokerProfessionalAccessBlockedModal>;
